import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Modal from 'components/Modal';
import Icon from 'components/Icon';

import DataService from 'lib/DataService';
import { copyToClipboard } from 'lib/copyToClipboard';

import {
	GhostButton,
	BigBlueButton,
	StyledLabel,
	StyledSelect,
} from 'lib/styles';

const Api = new DataService();

const Legend = styled.legend`
	font-weight: bold;
	font-size: 20px;
	margin: 0 0 8px;
`;
const Label = styled(StyledLabel)`
	margin: 0 0 8px;
`;

const Webview = styled.a`
	display: flex;
	flex-direction: row;
	align-content: center;
	align-items: center;

	color: #004a91;

	span {
		margin-right: 8px;
	}

	svg {
		fill: #004a91;
	}
`;

const Button = styled.button`
	display: flex;
	flex-direction: row;
	align-content: center;
	align-items: center;

	color: #004a91;
	border: 0;
	background-color: rgba(0,0,0,0);
	font-size: 100%;
	padding-left: 0;
	cursor: pointer;
	text-decoration: underline;

	span {
		margin-right: 8px;
	}

	svg {
		fill: #004a91;
	}
`;

class Pdf extends React.Component {
	state = {
	  quality: 'large',
	  requested: false,
	  url: false,
	  copied: false,
	}

	generate = () => {
	  if (!this.state.requested) {
	    this.setState({ requested: true, url: '' });

	    const brochureId = this.props.brochure.id;
	    const { quality } = this.state;

	    Api.getPdf({ brochureId, quality })
	      .then(response => {
	        if (this.mounted) {
			  console.log(response, this.props.brochure);
			  console.log('building', this.props.building);
	          this.setState({ requested: false });

	          if (response.result.pdf) {
	            // window.open(response.result.pdf);
							this.setState({ url: response.result.pdf });
							if (this.props.brochure.type === 'default') {
								const building = { ...this.props.building };
								building.spaces.forEach((space, i) => {
									if (space.default_brochure === brochureId) {
										const item = { ...space };
										item.default_brochure_pdf = response.result.pdf;
										building.spaces[i] = item;
									}
								});
								this.props.updateBuildingHandler(building);
							}
	          }
	        }
	      });
	  }
	}

	handleCopy = () => {
	  copyToClipboard(this.state.url);
	  this.setState({ copied: true });

	  setTimeout(() => {
	    this.setState({ copied: false });
	  }, 3000);
	}

	handleChange = event => {
	  this.setState({
	    url: '',
	    [event.target.name]: event.target.value,
	  });
	}

	componentDidMount() {
	  this.mounted = true;
	}

	componentWillUnmount() {
	  this.mounted = false;
	}

	render() {
	  const { t, lng, brochure: { id, i18n } } = this.props;

	  const qualityOptions = [
	    { value: 'original', name: t('brochure/PDF/generate/modal/quality/original') },
	    { value: 'large', name: t('brochure/PDF/generate/modal/quality/large') },
	    { value: 'small', name: t('brochure/PDF/generate/modal/quality/small') },
	  ];

	  const webviewUrl = `${this.props.baseUrl}/${lng}/e/${id}/${i18n[lng].slug}/`;

	  return (
	    <Modal
	      header={t('brochure/Share/title')}
	      body={(
	        <React.Fragment>

	          <Legend>{t('brochure/Share/Web brochure/label')}</Legend>
	          <Label htmlFor="web-brochure">{t('brochure/Share/Web brochure/address')}</Label>
	          <Webview target="_blank" href={webviewUrl} style={{ marginBottom: '32px' }}>
	            <Icon className="icon" icon="browser-window-new" />
	            {webviewUrl}
	          </Webview>


	          <Legend>PDF</Legend>
	          <Label htmlFor="quality">{t('brochure/PDF/generate/modal/quality')}</Label>
	          <StyledSelect
	            id={'quality'}
	            name="quality"
	            options={qualityOptions}
	            value={this.state.quality}
	            onChange={e => this.handleChange(e)}
	            style={{marginBottom: '16px'}}
	          />
	          <BigBlueButton onClick={this.generate} disabled={this.state.requested}>
	            {t(this.state.requested ? 'brochure/PDF/generate/modal/generating' : 'brochure/PDF/generate/modal/generate')}
	          </BigBlueButton>
	          {
	            this.state.url &&
							<Button onClick={this.handleCopy} style={{ marginTop: '16px' }}>
							  <Icon className="icon" icon={this.state.copied ? 'checkmark' : 'clipboard'} />
							  {t(this.state.copied ? 'brochure/PDF/copied to clipboard' : 'brochure/PDF/copy to clipboard')}
							</Button>
	          }

	        </React.Fragment>
	      )}
	      footer={(
	        <React.Fragment>
	          <GhostButton onClick={() => this.props.toggleGeneratePdfOpen()}>{t('brochure/PDF/generate/modal/close')}</GhostButton>
	        </React.Fragment>
	      )}
	    />
	  )
	}
}

Pdf.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	brochure: PropTypes.object,
	baseUrl: PropTypes.string,
	toggleGeneratePdfOpen: PropTypes.func,
}

export default translate('translations')(Pdf)
